export const getSlugFromURL = (url) => {
    return url.split('/')[url.split('/').length - 3].split('-').join(' ')
}